// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HS9z","questions":"styles_questions__3n2EG","footer":"styles_footer__SLj6v"};